// Laden mit Wiederholung für die Workflow-Seiten (Agent 4C): einmal laden, bei Bedarf neu, optional im Takt,
// solange der Tab sichtbar ist (die Läufe-Tabelle und die Listen halten sich so ohne Echtzeit-Ereignis aktuell).
import { useCallback, useEffect, useRef, useState } from "react";

export interface Geladen<T> {
  daten: T | null;
  fehler: unknown;
  laedt: boolean;
  neuLaden: () => Promise<void>;
  setzen: (d: T | null) => void;
}

export function useLaden<T>(laden: () => Promise<T>, abhaengig: readonly unknown[], takt?: number): Geladen<T> {
  const [daten, setDaten] = useState<T | null>(null);
  const [fehler, setFehler] = useState<unknown>(null);
  const [laedt, setLaedt] = useState(true);
  const ladeRef = useRef(laden);
  ladeRef.current = laden;
  const nummer = useRef(0);

  const neuLaden = useCallback(async () => {
    const mein = ++nummer.current;
    try {
      const d = await ladeRef.current();
      if (mein !== nummer.current) return;
      setDaten(d);
      setFehler(null);
    } catch (e) {
      if (mein === nummer.current) setFehler(e);
    } finally {
      if (mein === nummer.current) setLaedt(false);
    }
  }, []);

  useEffect(() => {
    setLaedt(true);
    void neuLaden();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, abhaengig);

  useEffect(() => {
    if (!takt) return;
    const id = window.setInterval(() => {
      if (document.visibilityState === "visible") void neuLaden();
    }, takt);
    return () => window.clearInterval(id);
  }, [takt, neuLaden]);

  return { daten, fehler, laedt, neuLaden, setzen: setDaten };
}
